import { CircularProgress, Grid, makeStyles } from "@material-ui/core";
import { Add, Cancel, Update } from "@material-ui/icons";
import { useAccessControl, useAuth } from "@airborne/react-admin";
import keyBy from "lodash/keyBy";
import * as React from "react";
import { useState } from "react";
import {
  Button,
  Create,
  Datagrid,
  ListContextProvider,
  TextField,
  TextInput,
  Toolbar,
  minValue,
  required,
  useNotify,
} from "react-admin";
import { Form } from "react-final-form";
import { useHistory } from "react-router-dom";
import CreatedByField from "../../../../../src/Components/ReferenceFields/CreatedBy/CreatedByField";
import UpdatedByField from "../../../../../src/Components/ReferenceFields/UpdatedBy/UpdatedByField";
import { SectionTitle } from "../../../../../src/Components/SectionTitle";
import { Separator } from "../../../../../src/Components/Separator";
import { useAppDataProvider } from "../../../../../src/dataprovider";
import { CustomDateField } from "../../../../Components/CustomDateField";
import { CustomDatetime } from "../../../../Components/CustomDatetime";
import { ModelState } from "../../Models/ModelStateEnum";
import {
  RequestShipmentArrivalPostModel,
  RequestShipmentArrivalPutModel,
} from "../../Models/RequestShipmentArrivalModel";
import { SourceRequestOrder } from "../Constant/Source";

const useStylesCreate = makeStyles({
  toolbar: {
    flex: "auto",
    justifyContent: "center",
    backgroundColor: "white",
  },
  defaultToolbar: {
    flex: "auto",
    justifyContent: "center",
  },
});

const RequestShipmentArrivalCreate = props => {
  const requestId = props.requestId;
  const [loading, setLoading] = useState(false);
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const history = useHistory();
  const classes = useStylesCreate();

  const CreateRequestShipmentArrivalButtonClick = async e => {
    CreateShipmentArrival(e);
  };

  const CreateShipmentArrival = e => {
    setLoading(true);
    let requestShipmentArrivalCreateModel: RequestShipmentArrivalPostModel = new RequestShipmentArrivalPostModel();

    requestShipmentArrivalCreateModel.RequestId = requestId;
    requestShipmentArrivalCreateModel.ArrivalDate = e.arrivalDate;
    requestShipmentArrivalCreateModel.IsComingFromIntegration = false;
    requestShipmentArrivalCreateModel.ManuelEntryReason = e.manuelEntryReason;

    dataProvider.postRequestArrivalInfo(requestShipmentArrivalCreateModel).then(result => {
      props?.finalCallBack?.();
      notify(`Record created`, "success", false, true);
      history.push("/requestorders/" + requestId + "/5");
      setLoading(false);
    });
  };

  return (
    <Form
      onSubmit={e => CreateRequestShipmentArrivalButtonClick(e)}
      render={({ handleSubmit, form, values }) => (
        <form>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <Create {...props}>
                <>
                  <Grid container direction="row" item xs={12} spacing={1} justify="space-around" alignItems="center">
                    <SectionTitle label="Shipment Arrival Info" />
                  </Grid>
                  <Separator />
                  <Grid container direction="row" xs={12} spacing={1} item justifyContent="center" alignItems="center">
                    <Grid item xs={12} sm={5}>
                      {/* <CustomDatetime
                        fullWidth
                        source="arrivalDate"
                        label="Shipment Arrival Date"
                        inputVariant={'dialog'}
                        variant="outlined"
                        showTime
                        minDate={props.flightDate}
                        validate={[required(), minValue(props.flightDate)]}
                      /> */}
                      <CustomDatetime
                        fullWidth
                        source="arrivalDate"
                        label="Shipment Arrival Date"
                        inputVariant={"dialog"}
                        variant="outlined"
                        showTime
                        minDate={props.flightDate}
                        validate={[required(), minValue(props.flightDate)]}
                      />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      <TextInput
                        source="manuelEntryReason"
                        label="Manuel Entry Reason"
                        //disabled={shipmentFormDisabled}
                        variant="outlined"
                        validate={required()}
                        fullWidth
                      />
                    </Grid>

                    <Separator />
                    <Toolbar {...props} placeholder="" classes={classes}>
                      <Button
                        label={loading ? "Shipment Arrival Info is creating!" : "Shipment Arrival Info Create"}
                        disabled={loading}
                        size="medium"
                        variant="contained"
                        color="primary"
                        onClick={() => handleSubmit()}
                      >
                        {loading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
                      </Button>
                    </Toolbar>
                  </Grid>
                </>
              </Create>
            </Grid>
          </Grid>
        </form>
      )}
    />
  );
};

const useStylesEdit = makeStyles({
  toolbar: {
    flex: "auto",
    justifyContent: "end",
    backgroundColor: "white",
  },
  defaultToolbar: {
    flex: "auto",
    justifyContent: "end",
  },
});

const RequestShipmentArrivalEdit = props => {
  const [approveButtonShown, setApproveButtonShown] = useState(false);
  const [loading, setLoading] = useState(false);
  const [shipmentFormDisabled, setShipmentFromDisabled] = useState(true);
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const history = useHistory();
  const { user } = useAuth();
  const { canPerform: canEditOnlyShow } = useAccessControl(SourceRequestOrder, "editonlyshow");
  const requestId = props.requestId;
  const classes = useStylesEdit();

  const openEditableFields = () => {
    setApproveButtonShown(true);
    setShipmentFromDisabled(false);
  };

  const UpdateArrivalInfoButtonClick = async e => {
    UpdateArrivalInfo(e);
  };

  const UpdateArrivalInfo = e => {
    setLoading(true);
    let requestShipmentArrivalUpdateModel: RequestShipmentArrivalPutModel = new RequestShipmentArrivalPutModel();

    requestShipmentArrivalUpdateModel.id = props.requestshipmentarrivalinfo.id;
    requestShipmentArrivalUpdateModel.RequestId = props.requestshipmentarrivalinfo.requestId;
    requestShipmentArrivalUpdateModel.ArrivalDate = e.arrivalDate;
    requestShipmentArrivalUpdateModel.IsComingFromIntegration = false;
    requestShipmentArrivalUpdateModel.ManuelEntryReason = e.manuelEntryReason;
    requestShipmentArrivalUpdateModel.updatedBy = user?.employeeId;
    requestShipmentArrivalUpdateModel.updatedDate = new Date();

    dataProvider
      .putRequestArrivalInfo(requestShipmentArrivalUpdateModel)
      .then(result => {
        props?.finalCallBack?.();
        notify(`Record updated`, "success", false, true);
        setApproveButtonShown(false);
        setShipmentFromDisabled(true);
        history.push("/requestorders/" + requestId + "/5");
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  const cancelUpdate = () => {
    setApproveButtonShown(false);
    setShipmentFromDisabled(true);
  };

  return (
    <Form
      onSubmit={e => UpdateArrivalInfoButtonClick(e)}
      render={({ handleSubmit, form, values }) => (
        <form>
          <Grid container spacing={2}>
            {/* <Grid item xs={12} sm={9}> */}
            <>
              <Grid container direction="row" item xs={12} spacing={1} justify="space-around" alignItems="center">
                <SectionTitle label="Shipment Arrival Info" />
              </Grid>
              <Separator />
              <Grid container direction="row" xs={12} spacing={1} item justify="flex-start" alignItems="center">
                <Grid item xs={12} sm={6}>
                  {/* <CustomDatetime
                    disabled={shipmentFormDisabled}
                    defaultValue={props.requestshipmentarrivalinfo.arrivalDate}
                    fullWidth
                    source="arrivalDate"
                    label="Shipment Arrival Date"
                    inputVariant={'dialog'}
                    variant="outlined"
                    minDate={props.flightDate}
                    validate={[required(), minValue(props.flightDate)]}
                  /> */}
                  <CustomDatetime
                    fullWidth
                    disabled={shipmentFormDisabled}
                    defaultValue={props.requestshipmentarrivalinfo.arrivalDate}
                    source="arrivalDate"
                    label="Shipment Arrival Date"
                    inputVariant={"dialog"}
                    variant="outlined"
                    minDate={props.flightDate}
                    validate={[required(), minValue(props.flightDate)]}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextInput
                    source="manuelEntryReason"
                    label="Manuel Entry Reason"
                    disabled={shipmentFormDisabled}
                    defaultValue={props.requestshipmentarrivalinfo.manuelEntryReason}
                    validate={required()}
                    variant="outlined"
                    fullWidth
                  />
                </Grid>

                <Separator />
                <Toolbar {...props} placeholder="" classes={classes}>
                  {approveButtonShown === false && canEditOnlyShow ? (
                    <Button
                      label="Update Arrival Info"
                      disabled={loading}
                      size="medium"
                      variant="contained"
                      style={{ background: "#ffc107" }}
                      onClick={() => openEditableFields()}
                    >
                      {<Update />}
                    </Button>
                  ) : (
                    <Grid></Grid>
                  )}

                  {approveButtonShown === true && canEditOnlyShow ? (
                    <>
                      <Button
                        label={loading ? "Shipment Arrival Info is updating!" : "Update Shipment Arrival Info "}
                        disabled={loading}
                        size="medium"
                        variant="contained"
                        style={{ margin: "8px", background: "seagreen" }}
                        onClick={() => handleSubmit()}
                      >
                        {loading ? <CircularProgress size="2rem" color="secondary" /> : <Update />}
                      </Button>
                      <Button
                        label={loading ? "Cancel!" : "Cancel "}
                        disabled={loading}
                        size="medium"
                        variant="contained"
                        color="primary"
                        style={{ margin: "8px" }}
                        onClick={() => cancelUpdate()}
                      >
                        {<Cancel />}
                      </Button>
                    </>
                  ) : (
                    <Grid></Grid>
                  )}
                </Toolbar>
              </Grid>
            </>
            {/* </Grid> */}
          </Grid>
        </form>
      )}
    />
  );
};

const RequestShipmentArrivalView = props => {
  const arrivalList = [] as any;
  arrivalList.push(props.requestshipmentarrivalinfo);

  return (
    <ListContextProvider
      value={{
        data: keyBy(arrivalList, "id"),
        ids: arrivalList.map(({ id }) => id),
        currentSort: { field: "id", order: "ASC" },
      }}
    >
      <Datagrid>
        {/* <CustomDateField label="Shipment Arrival Date" source="arrivalDate" /> */}
        <CustomDateField label="Shipment Arrival Date" source="arrivalDate" />
        <TextField label="Manuel Entry Reason" source="manuelEntryReason" />
        <CreatedByField label="CREATED BY" link={false} />
        <CustomDateField source="createdDate" label="CREATED DATE" />
        <UpdatedByField label="Updated By" link={false} />
        <CustomDateField source="updatedDate" label="UPDATED DATE" />
      </Datagrid>
    </ListContextProvider>
  );
};

const RequestShipmentArrival = props => {
  const [tabType, setTabType] = React.useState(ModelState.Create);
  React.useEffect(() => {
    var tempTabType =
      props?.requestDetailData?.isFlightArrived === false || props?.requestShipmentArrivalInfo === null
        ? ModelState.Create
        : props?.requestShipmentArrivalInfo?.isComingFromIntegration === false
          ? ModelState.Edit
          : ModelState.View;
    setTabType(tempTabType);
  }, [props?.requestServiceableData]);
  switch (tabType) {
    case ModelState.Create:
      return (
        <RequestShipmentArrivalCreate
          resource="/requestarrivalinfos"
          basePath=""
          flightDate={props.flightDate}
          requestId={props.requestId}
          finalCallBack={e => props.parentCallBack()}
        />
      );
    case ModelState.Edit:
      return (
        <RequestShipmentArrivalEdit
          resource="/requestarrivalinfos"
          basePath=""
          requestshipmentarrivalinfo={props.requestShipmentArrivalInfo}
          requestDetailData={props.requestDetailData}
          requestId={props.requestId}
          flightDate={props.flightDate}
          finalCallBack={e => props.parentCallBack()}
        />
      );
    default:
      return (
        <RequestShipmentArrivalView
          requestshipmentarrivalinfo={props.requestShipmentArrivalInfo}
          requestDetailData={props.requestDetailData}
          requestId={props.requestId}
        />
      );
  }
};

export default RequestShipmentArrival;
